module.exports = __webpack_public_path__ + "img/public/SiteIcons/hostStepIcons/booking.svg?5f91f913";